/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type DispoAcceptBookingMutationVariables = {
    id: string;
};
export type DispoAcceptBookingMutationResponse = {
    readonly acceptBooking: {
        readonly bookingId: string;
    };
};
export type DispoAcceptBookingMutation = {
    readonly response: DispoAcceptBookingMutationResponse;
    readonly variables: DispoAcceptBookingMutationVariables;
};



/*
mutation DispoAcceptBookingMutation(
  $id: String!
) {
  acceptBooking(id: $id) {
    bookingId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "Booking",
    "kind": "LinkedField",
    "name": "acceptBooking",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "bookingId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DispoAcceptBookingMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DispoAcceptBookingMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0bdfabe9fd5f3a541684ebf7bab44df5",
    "id": null,
    "metadata": {},
    "name": "DispoAcceptBookingMutation",
    "operationKind": "mutation",
    "text": "mutation DispoAcceptBookingMutation(\n  $id: String!\n) {\n  acceptBooking(id: $id) {\n    bookingId\n  }\n}\n"
  }
};
})();
(node as any).hash = 'ab1a694e882f727c26432bd4ab8bd3e4';
export default node;
